module.exports = __webpack_public_path__ + "img/bdtApk.e2c1dd08.png";